module.exports = __webpack_public_path__ + "static/media/reservationGreen.3b8ae3f4.svg";